import { createAction, ActionsUnion } from "../definitions";
import { RouteActionTypes } from "./types";
import { IRoute } from "../../model/Message";

export interface IRoutePayload {
    userId: string;
    routes?: IIdDictionary<IRoute>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const RouteActions = {
    setRoutes: (payload: IRoutePayload) => createAction(RouteActionTypes.SET_ROUTES, payload),
    clearRoutes: (payload: IRoutePayload) => createAction(RouteActionTypes.CLEAR_ROUTES, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RouteActions = ActionsUnion<typeof RouteActions>;